/* ============================================================
   OVI — i18n.js
   Micro-moteur de traduction. La copy vit dans un objet COPY
   défini par chaque page ( { fr:{...}, en:{...} } ), JAMAIS en dur
   dans la logique du markup. Le markup ne porte que des clés
   data-i18n="...". Passer FR -> EN = remplir COPY.en (ou charger
   un fichier fr.json / en.json plus tard). Le texte FR inline
   sert de repli si JS est coupé.
   ============================================================ */
(function () {
  function apply(COPY, lang) {
    var d = (COPY && COPY[lang]) || (COPY && COPY.fr) || {};
    document.querySelectorAll("[data-i18n]").forEach(function (el) {
      var key = el.getAttribute("data-i18n");
      if (d[key] != null) el.innerHTML = d[key];
    });
    document.querySelectorAll("[data-i18n-attr]").forEach(function (el) {
      // format: "placeholder:key,aria-label:key2"
      el.getAttribute("data-i18n-attr").split(",").forEach(function (pair) {
        var p = pair.split(":");
        if (p.length === 2 && d[p[1]] != null) el.setAttribute(p[0].trim(), d[p[1]].trim());
      });
    });
    document.documentElement.lang = lang;
    document.querySelectorAll(".langsw button").forEach(function (b) {
      b.classList.toggle("on", b.getAttribute("data-lang") === lang);
    });
  }

  window.OVI = {
    init: function (COPY, initial) {
      var start = initial || "fr";
      apply(COPY, start);
      var sw = document.querySelector(".langsw");
      if (sw) {
        sw.addEventListener("click", function (e) {
          var b = e.target.closest("button[data-lang]");
          if (b) apply(COPY, b.getAttribute("data-lang"));
        });
      }
    }
  };
})();

/* Petites interactions communes aux maquettes (sélecteurs) */
document.addEventListener("click", function (e) {
  var size = e.target.closest(".size");
  if (size && size.parentElement) {
    size.parentElement.querySelectorAll(".size").forEach(function (s) { s.classList.remove("sel"); });
    size.classList.add("sel");
  }
  var plan = e.target.closest(".plan");
  if (plan && plan.closest(".plans")) {
    plan.closest(".plans").querySelectorAll(".plan").forEach(function (p) { p.classList.remove("sel"); });
    plan.classList.add("sel");
    // reflète le prix choisi dans la barre sticky si présente
    var price = plan.getAttribute("data-price");
    var bar = document.querySelector(".sticky-cta .p");
    if (price && bar) bar.textContent = price;
  }
});
